import type { Language } from '../types/language';
import type { PlanningType } from '../types/quote';

export interface LocalizedOption<T extends string = string> {
  value: T;
  label: Record<Language, string>;
}

export const planningOptions: LocalizedOption<PlanningType>[] = [
  { value: 'Private Dance Classes', label: { en: 'Private Dance Classes', es: 'Clases privadas de baile' } },
  { value: '1-on-1 Coaching', label: { en: '1-on-1 Coaching', es: 'Coaching 1 a 1' } },
  { value: 'Couples Lessons', label: { en: 'Couples Lessons', es: 'Clases para parejas' } },
  { value: 'Wedding', label: { en: 'Wedding', es: 'Boda' } },
  { value: 'Quinceañera', label: { en: 'Quinceañera', es: 'Quinceañera' } },
  { value: 'Group Coaching', label: { en: 'Group Coaching', es: 'Coaching para grupos' } },
  { value: 'Competition Coaching', label: { en: 'Competition Coaching', es: 'Coaching para competencias' } },
  { value: 'Competition Choreography', label: { en: 'Competition Choreography', es: 'Coreografía para competencias' } },
  { value: 'Custom Choreography', label: { en: 'Custom Choreography', es: 'Coreografía personalizada' } },
  { value: 'Corporate Event', label: { en: 'Corporate Event', es: 'Evento corporativo' } },
  { value: 'Professional Performance', label: { en: 'Professional Performance', es: 'Performance profesional' } },
  { value: 'Live Entertainment', label: { en: 'Live Entertainment', es: 'Entretenimiento en vivo' } },
  { value: 'School / Studio Project', label: { en: 'School / Studio Project', es: 'Proyecto de escuela / estudio' } },
  { value: 'Artist / Music Video', label: { en: 'Artist / Music Video', es: 'Artista / Video musical' } },
  { value: 'Other', label: { en: 'Other', es: 'Otro' } },
];

export const locationOptions: LocalizedOption[] = [
  { value: 'Denver', label: { en: 'Denver', es: 'Denver' } },
  { value: 'Denver Metro', label: { en: 'Denver Metro', es: 'Área metropolitana de Denver' } },
  { value: 'Colorado', label: { en: 'Colorado', es: 'Colorado' } },
  { value: 'Other', label: { en: 'Other', es: 'Otro' } },
  { value: 'Not sure yet', label: { en: 'Not sure yet', es: 'Aún no estoy seguro' } },
];

export const groupSizeOptions: LocalizedOption[] = ['1', '2', '3–5', '6–10', '11–20', '20+'].map((value) => ({
  value,
  label: { en: value, es: value },
}));
